import React, {useContext, useEffect} from 'react'
import {OfferContext} from "../../../context/OfferContext";
import { Form, InputNumber } from "antd";

const OfferCreatePrice = ({rowIndex ,record}) => {

    const [form] = Form.useForm()
    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        if (record.unitPrice){
            form.setFieldsValue({
                [`${rowIndex}-stockPrice`]: record.unitPrice
            })
            return
        }
        form.setFieldsValue({
            [`${rowIndex}-stockPrice`]: record.data ? record.data.price : 0
        })
    })

    const handlePriceChange = ({target}) => {
        let mockContext = [...materials]
        mockContext[rowIndex].unitPrice = target.value
        setMaterials(mockContext)
    }


    return (
        <React.Fragment>

            <Form form={form}>
                <Form.Item
                    name={`${rowIndex}-stockPrice`}
                    rules={[{required: true, message: 'Bu Alan Zorunludur'}]}
                >
                    <InputNumber
                        disabled={!record.data}
                        onBlur={handlePriceChange}
                        step={0.1}
                    />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferCreatePrice